import { useParams, useNavigate } from "react-router-dom";
import { STRATEGIES } from "../data/platformStrategiesData";
import { useState } from "react";
import * as Icons from "lucide-react";
import { ArrowLeft, ChevronRight, Sparkles } from "lucide-react";
import { DetailDrawer } from "../components/DetailDrawer";

const Icon = ({ name, className, color }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} style={{ color }} strokeWidth={1.5} />;
};

export default function StrategyDetail() {
  const { platform } = useParams();
  const nav = useNavigate();
  const strat = STRATEGIES[platform];
  const [openItem, setOpenItem] = useState(null);

  if (!strat) {
    return (
      <div className="text-center py-20">
        <p className="text-zinc-400 mb-4">Plateforme inconnue.</p>
        <button onClick={() => nav("/strategies-plateformes")} className="text-[#CCFF00] underline">Retour au hub</button>
      </div>
    );
  }

  return (
    <div className="space-y-8 animate-fadeUp" data-testid={`strat-detail-${platform}`}>
      <button onClick={() => nav("/strategies-plateformes")} className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-wider text-zinc-500 hover:text-[#CCFF00] transition">
        <ArrowLeft className="w-3 h-3" /> Retour aux stratégies
      </button>

      <header className="flex items-start gap-5">
        <div className="w-14 h-14 rounded-sm flex items-center justify-center border shrink-0" style={{ background: `${strat.color}15`, borderColor: `${strat.color}40` }}>
          <Icon name={strat.icon} className="w-7 h-7" color={strat.color} />
        </div>
        <div className="border-l-2 border-[#CCFF00] pl-5 flex-1">
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] mb-2" style={{ color: strat.color }}>// STRATÉGIE {strat.name.toUpperCase()}</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tight">{strat.name}</h1>
          <p className="text-zinc-400 mt-2 max-w-3xl">{strat.tagline}</p>
        </div>
      </header>

      {strat.sections.map((section, sidx) => (
        <section key={sidx}>
          <h2 className="font-display text-xl font-semibold text-white mb-4 flex items-center gap-2">
            <span className="font-mono text-[10px] text-[#CCFF00]">[{String(sidx + 1).padStart(2, "0")}]</span>
            {section.title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {section.items.map((item, iidx) => (
              <button
                key={iidx}
                onClick={() => setOpenItem({ ...item, _platform: strat.name })}
                data-testid={`strat-item-${sidx}-${iidx}`}
                className="text-left group border border-[#1E1E24] hover:border-[#CCFF00]/40 bg-[#0A0A0C] hover:bg-[#0C0C0E] rounded-sm p-5 transition-all"
              >
                <div className="flex items-start justify-between gap-3 mb-2">
                  <div className="text-white text-sm font-medium leading-tight">{item.head}</div>
                  <ChevronRight className="w-4 h-4 text-zinc-600 group-hover:text-[#CCFF00] shrink-0 transition" />
                </div>
                <p className="text-sm text-zinc-400 leading-relaxed">{item.body}</p>
                <div className="mt-3 flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider text-[#00D4FF] opacity-60 group-hover:opacity-100 transition">
                  <Sparkles className="w-3 h-3" />
                  <span>{item.details ? "Deep dive" : "Approfondir IA"}</span>
                </div>
              </button>
            ))}
          </div>
        </section>
      ))}

      <DetailDrawer
        open={!!openItem}
        onOpenChange={(o) => !o && setOpenItem(null)}
        title={openItem?.head || ""}
        subtitle={openItem?.body}
        details={openItem?.details}
        aiContext={openItem ? {
          topic: openItem.head,
          context: `Plateforme: ${openItem._platform}. Description: ${openItem.body}. Stratégie complète attendue.`,
          platform: openItem._platform
        } : null}
      />
    </div>
  );
}
